/**
 * Leitura/escrita de cookies no browser — ponto único (antes o mesmo regex e
 * a mesma montagem de string estavam copiados em session, selectedStore e no
 * store de auth). Para cookies server-side, ver `app/api/auth/_cookies.ts`.
 */

/** Lê o valor (decodificado) de um cookie no browser; null se ausente. */
export function readClientCookie(name: string): string | null {
    if (typeof document === "undefined") return null;

    const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${escaped}=([^;]+)`));
    return match?.[1] ? decodeURIComponent(match[1]) : null;
}

/** Grava um cookie no browser (path=/, sameSite=lax, secure em https). */
export function writeClientCookie(name: string, value: string, maxAgeSeconds: number): void {
    const secure = window.location.protocol === "https:" ? "; secure" : "";
    document.cookie =
        `${name}=${encodeURIComponent(value)}` +
        `; max-age=${maxAgeSeconds}; path=/; samesite=lax${secure}`;
}
